import React from "react";
import { useMediaQuery, Box, Stack, Typography, Theme } from "@mui/material";
import { User } from "src/constants/types";
import { GradientBanner } from './GradientBanner.styles';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface ProcessingStateViewProps {
  profile?: User | null;
}

export const ProcessingStateView: React.FC<ProcessingStateViewProps> = ({ profile }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  return (
    <Box width="100%" p={0}>
      <GradientBanner accent="success">
        <Stack
          direction={isMobile ? 'column' : 'row'}
          alignItems="flex-start"
          justifyContent="space-between"
          spacing={1}
          useFlexGap
          px={2}
          pt={1.25}
          pb={1}
        >
          <Stack direction="row" alignItems="flex-start" spacing={2} useFlexGap>
            <Box>
              <Typography
                variant="h6"
                display="flex"
                alignItems="center"
                gap={0.5}
                lineHeight={0}
                fontWeight="fontWeightBold"
              >
                All Set on Your End!
                <CheckCircleIcon fontSize="small" />
              </Typography>
              <Typography variant="body2" mt={0.5}>
                We have submitted your information to the carriers for review and approval.
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </GradientBanner>

      <Box pt={1.25}>
        <Box>
          <Box display="grid" gridTemplateColumns={{ xs: '1fr', md: '1fr 1fr' }} gap={2} pb={0}>
            <Stack direction="row" spacing={2} useFlexGap pl={1.5}>
              <Stack
                alignItems="center"
                justifyContent="center"
                flexShrink={0}
                mt={-2}
                color="success.dark"
              >
                <CheckCircleIcon />
              </Stack>
              <Box>
                <Typography variant="body1" fontWeight="fontWeightSemiBold">
                  Information Submitted
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  All documents received
                </Typography>
              </Box>
            </Stack>

            <Stack direction="row" spacing={2} useFlexGap pl={1.5}>
              <Box display="flex" flexShrink={0} color="grey.400">
                <ScheduleIcon />
              </Box>
              <Box>
                <Typography variant="body1" fontWeight="fontWeightSemiBold">
                  Approval & Activation
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Typically within several business days
                </Typography>
              </Box>
            </Stack>
          </Box>

          <Stack direction="row" alignItems="flex-start" spacing={1.5} useFlexGap p={1.5} pb={0} mb={1}>
            <NotificationsIcon color="primary" fontSize="small" />
            <Typography variant="body2" color="text.secondary">
              We&apos;ll notify you when approved. You&apos;ll receive an email at {profile?.email || 'your email'} as soon as your account is ready.
            </Typography>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};
